import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { Web3Provider } from './context/Web3Context';

// Components
import Navbar from './components/Navbar';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import LiveMap from './pages/LiveMap';
import Report from './pages/Report';
import Wallet from './pages/Wallet';
import Community from './pages/Community';
import AdminDashboard from './pages/AdminDashboard';
import Profile from './pages/Profile';
import HowToUse from './pages/HowToUse';
import AIAssistant from './pages/AIAssistant'; // <--- NEW IMPORT

// Global Styles
import './styles/global.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Web3Provider>
          <div className="app-main">
            <Navbar />
            
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              
              <Route path="/map" element={<LiveMap />} />
              <Route path="/report" element={<Report />} />
              <Route path="/community" element={<Community />} />
              <Route path="/how-to-use" element={<HowToUse />} />
              <Route path="/ai-assistant" element={<AIAssistant />} /> {/* <--- NEW ROUTE */}
              
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/profile" element={<Profile />} />
              
              <Route path="/admin" element={<AdminDashboard />} />
              
              <Route path="*" element={<Landing />} />
            </Routes>
          </div>
        </Web3Provider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;